import { render, staticRenderFns } from "./c-switch.vue?vue&type=template&id=2b40e0c6&"
import script from "./c-switch.vue?vue&type=script&lang=js&"
export * from "./c-switch.vue?vue&type=script&lang=js&"
import style0 from "./c-switch.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports